// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * A static route attached to one netdef.
 */
export class RouteConfig implements flatbuffers.IUnpackableObject<RouteConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): RouteConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsRouteConfig(bb: flatbuffers.ByteBuffer, obj?: RouteConfig): RouteConfig {
    return (obj || new RouteConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsRouteConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: RouteConfig,
  ): RouteConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new RouteConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Netdef id this route belongs to.
   */
  on(): string | null;
  on(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  on(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * "default" or a CIDR. Must match the family of `via`.
   */
  to(): string | null;
  to(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  to(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  via(): string | null;
  via(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  via(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Integer only — netplan does not accept table names like "main".
   * Omit (0) for the main table.
   */
  tableId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  metric(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  onLink(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startRouteConfig(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addOn(builder: flatbuffers.Builder, onOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, onOffset, 0);
  }

  static addTo(builder: flatbuffers.Builder, toOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, toOffset, 0);
  }

  static addVia(builder: flatbuffers.Builder, viaOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, viaOffset, 0);
  }

  static addTableId(builder: flatbuffers.Builder, tableId: number) {
    builder.addFieldInt32(3, tableId, 0);
  }

  static addMetric(builder: flatbuffers.Builder, metric: number) {
    builder.addFieldInt32(4, metric, 0);
  }

  static addOnLink(builder: flatbuffers.Builder, onLink: boolean) {
    builder.addFieldInt8(5, +onLink, +false);
  }

  static endRouteConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createRouteConfig(
    builder: flatbuffers.Builder,
    onOffset: flatbuffers.Offset,
    toOffset: flatbuffers.Offset,
    viaOffset: flatbuffers.Offset,
    tableId: number,
    metric: number,
    onLink: boolean,
  ): flatbuffers.Offset {
    RouteConfig.startRouteConfig(builder);
    RouteConfig.addOn(builder, onOffset);
    RouteConfig.addTo(builder, toOffset);
    RouteConfig.addVia(builder, viaOffset);
    RouteConfig.addTableId(builder, tableId);
    RouteConfig.addMetric(builder, metric);
    RouteConfig.addOnLink(builder, onLink);
    return RouteConfig.endRouteConfig(builder);
  }

  unpack(): RouteConfigT {
    return new RouteConfigT(
      this.on(),
      this.to(),
      this.via(),
      this.tableId(),
      this.metric(),
      this.onLink(),
    );
  }

  unpackTo(_o: RouteConfigT): void {
    _o.on = this.on();
    _o.to = this.to();
    _o.via = this.via();
    _o.tableId = this.tableId();
    _o.metric = this.metric();
    _o.onLink = this.onLink();
  }

  unpackFields(...fields: string[]): RouteConfigT {
    const t = new RouteConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("on")) {
      t.on = this.on();
    }
    if (fieldSet.has("to")) {
      t.to = this.to();
    }
    if (fieldSet.has("via")) {
      t.via = this.via();
    }
    if (fieldSet.has("table_id")) {
      t.tableId = this.tableId();
    }
    if (fieldSet.has("metric")) {
      t.metric = this.metric();
    }
    if (fieldSet.has("on_link")) {
      t.onLink = this.onLink();
    }
    return t;
  }
}

export class RouteConfigT implements flatbuffers.IGeneratedObject {
  constructor(
    public on: string | Uint8Array | null = null,
    public to: string | Uint8Array | null = null,
    public via: string | Uint8Array | null = null,
    public tableId: number = 0,
    public metric: number = 0,
    public onLink: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const on = this.on !== null ? builder.createString(this.on!) : 0;
    const to = this.to !== null ? builder.createString(this.to!) : 0;
    const via = this.via !== null ? builder.createString(this.via!) : 0;

    return RouteConfig.createRouteConfig(
      builder,
      on,
      to,
      via,
      this.tableId,
      this.metric,
      this.onLink,
    );
  }

  clone(): RouteConfigT {
    const obj = new RouteConfigT();
    obj.on = this.on;
    obj.to = this.to;
    obj.via = this.via;
    obj.tableId = this.tableId;
    obj.metric = this.metric;
    obj.onLink = this.onLink;
    return obj;
  }

  equals(other: RouteConfigT): boolean {
    if (this.on !== other.on) return false;
    if (this.to !== other.to) return false;
    if (this.via !== other.via) return false;
    if (this.tableId !== other.tableId) return false;
    if (this.metric !== other.metric) return false;
    if (this.onLink !== other.onLink) return false;
    return true;
  }
}

export function verifyRouteConfig(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 1);
  } finally {
    verifier.popDepth();
  }
}
